module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp2_7016.682919d5.png";